import { inject } from 'vue';
import { ACTION_ENGINE_KEY } from '../plugins/actionEngine.js';
import { ActionCache } from '../actions.js';

// Composable to inject the action engine in components, providing a clean API for components to interact with actions.
export function useActions() {
	const actionEngine = inject(ACTION_ENGINE_KEY);
	
	if (!actionEngine) {
		throw new Error('Action engine not found. Make sure the action engine plugin is installed.');
	}
	
	return actionEngine;
}

// Specialized composable for UX components that need to handle actions.
export function useUxActions() {
	const actionEngine = useActions();
	
	// Helper to generate contextual menu items for a given data item or row. Returns empty array, or an array of menu items (text, icon, actionId).
	// Set preview to true to render for a preview mode where actions can be edited and not executed. Note that you will have to add onItemClick handlers for
	// all menu items returned here yourself.
	const generateContextMenuFromActions = (data, preview = false) => {
		console.log("Generating context menu from actions for data = ", data);
		const menu = [];
		if (preview) {
			menu.push({
				text: "Add action: context menu",
				icon: "toolbox",
				beginGroup: true,
				actionId: '_new',
			});
		}
		// TODO: Check data and component source to further filter these actions.
		const actions = ActionCache.getTriggers('contextmenu');
		if (!actions)
			return menu;
		
		menu.push(...actions.map(action => {
			const trigger = action._trigger;
			if (!preview && (!trigger || !trigger.type || !trigger.data))
				return null;
			console.log("Processing action & trigger:", action, trigger);
			return {
				text: (preview ? 'Edit: ' : '') + (trigger.data.label || action.name || `Action #${action.id}`),
				icon: trigger.data.icon || 'isblank',
				actionId: action.id
			};
		}).filter(Boolean));
		return menu;
	};
	
	// Helper to execute action with component context
	const executeWithContext = async (actionId, additionalContext = {}) => {
		
		const context = {
			// Additional default context can be added here.
			...additionalContext
		};
		
		const trigger = ActionCache.getTriggerForGraphId(actionId);
		console.log(trigger, context);
		// return await actionEngine.executeAction(actionId, context);
	};
	
	// Helper to register component-specific actions
	const registerComponentActions = (componentId, actions) => {
		for (const [actionName, config] of Object.entries(actions)) {
			const actionId = `${componentId}.${actionName}`;
			actionEngine.registerAction(actionId, config);
		}
	};
	
	// Helper to handle common UX component events
	const handleEvent = async (eventType, eventData, actionId) => {
		const context = {
			eventType,
			eventData,
			timestamp: Date.now()
		};
		
		if (actionId) {
			return await executeWithContext(actionId, context);
		}
	};
	
	return {
		...actionEngine,
		generateContextMenuFromActions,
		executeWithContext,
		registerComponentActions,
		handleEvent
	};
} 